// extracted by mini-css-extract-plugin
export default {"star":"star_star__L6vhV","star--large":"star_star--large__e5xO9"};